import { render, staticRenderFns } from "./AlertTotal.vue?vue&type=template&id=46162621"
import script from "./AlertTotal.vue?vue&type=script&lang=js"
export * from "./AlertTotal.vue?vue&type=script&lang=js"
import style0 from "./AlertTotal.vue?vue&type=style&index=0&id=46162621&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports